import styled from 'styled-components'

export const Main = styled.main`
  display: flex;
  max-height: 100vh;
  max-width: 100vw;
  font-family: 'Barlow';
`
